import axios from "axios";
import { ROOT_URL } from "./config";

export function handleDelete(req) {
  return axios.patch(ROOT_URL + `/api/v1/comment/${req.id}/`, req.data, {
    headers: req.headers,
  });
}
